export default "__VITE_ASSET__DeJyAMfF__"